/**
 * Портал накладного шару (components.md, розд. 8a): елемент шару в `body`, а якщо якір — у відкритому
 * `<dialog>` чи в іншому шарі, то в ньому. Спільний для `Popover` (статична частина) і відкритого
 * шару лінивого модуля (`layer-behavior.tsx`, `OpenLayer`).
 */
import { createElement, type HTMLAttributes, type ReactNode, type ReactPortal } from 'react';
import { createPortal } from 'react-dom';
import type { PopoverTag } from './layer-types.ts';

/** Куди нести шар: найближчий шар чи відкритий `<dialog>` якоря, інакше `body`. */
export function layerContainer(anchor: HTMLElement | null): HTMLElement {
  return anchor?.closest<HTMLElement>('[data-layer], dialog[open]') ?? document.body;
}

export interface LayerPortalOptions {
  as: PopoverTag;
  className: string | undefined;
  id: string;
  setRef: (node: HTMLElement | null) => void;
  /** Поведінка шару ще йде: шар невидимий (`popover.css`, `[data-pending]`). */
  pending: boolean;
  anchor: HTMLElement | null;
  rest: HTMLAttributes<HTMLElement>;
  children: ReactNode;
}

export function layerPortal(o: LayerPortalOptions): ReactPortal {
  return createPortal(
    createElement(
      o.as,
      {
        ...o.rest,
        ref: o.setRef,
        id: o.id,
        className: o.className ? `layer ${o.className}` : 'layer',
        'data-layer': '',
        'data-pending': o.pending ? '' : undefined,
      },
      o.children,
    ),
    layerContainer(o.anchor),
  );
}
